// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202603021533/js/" + chunkId + "." + {"44":"c25452d9","225":"5155c1bb","481":"c1de642b","486":"246f1ed7","770":"1bd18622"}[chunkId] + ".0.7753650621865076.chunk.js";
};